/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const speedometer_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#speedometer_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M20.043 8C17.99 5.872 15.13 4.524 12 4.5 8.907 4.523 6.048 5.873 3.986 8M12 4.5v2m-11.245 9H3m-2.245 0c.09-2.879 1.317-5.525 3.231-7.5M.755 15.5c-.02.666-.005 1.334-.005 2a2 2 0 0 0 2 2H9M3.986 8 5.5 9.5M20.043 8 18.5 9.5M20.043 8c1.904 1.974 3.114 4.619 3.202 7.5m0 0H21m2.245 0c.02.666.005 1.334.005 2a2 2 0 0 1-2 2H15m-6 0V19c0-1.634 1.366-3 3-3 .172 0 .34.015.505.044M9 19.5h6m0 0V19c0-1.462-1.094-2.71-2.495-2.956m0 0L14 11"
      />
    </g>
    <defs>
      <clipPath id="speedometer_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default speedometer_medium
